const vowels = new Set("aeiouAEIOU");

// This should do, but we could always add a large dependency to do this "even
// better" if we wanted: https://github.com/EamonNerbonne/a-vs-an/
// But it would probably be better to just add exceptions if/when we find them.
export const aOrAn = (text, capitalize = false) => {
  if (!text) {
    return "";
  }

  let firstLetter = "a";
  if (capitalize) {
    firstLetter = "A";
  }

  return firstLetter + (vowels.has(text[0]) ? "n " : " ") + text;
};

export const toCamelCase = (str) =>
  str
    ?.toLowerCase()
    .split("_")
    .reduce(
      (acc, part, index) =>
        acc + (index === 0 ? part : part[0].toUpperCase() + part.slice(1)),
      "",
    );

export const toCapitalized = (str) =>
  str
    ?.toLowerCase()
    .split(" ")
    .map((part) => part[0].toUpperCase() + part.slice(1))
    .join(" ");

export const currencyFormat = (value, numberFormatOptions) =>
  new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
    ...numberFormatOptions,
  }).format(value);

export const percentageFormat = (value, numberFormatOptions) =>
  new Intl.NumberFormat("en-US", {
    style: "percent",
    maximumFractionDigits: 2,
    ...numberFormatOptions,
  }).format(value);

export const compactCurrencyFormat = (value, numberFormatOptions) => {
  return currencyFormat(value ?? 0, {
    notation: "compact",
    maximumIntegerDigits: 3,
    maximumFractionDigits: 1,
    ...numberFormatOptions,
  });
};
